<deloitteai-header [logoUrl]="logoUrl" [desktopHamburgerLogoUrl]="desktopHamburgerLogoUrl"></deloitteai-header>
<div class="page-body">
    <aihub-loader></aihub-loader>
    <router-outlet></router-outlet>
</div>
<deloitteai-footer></deloitteai-footer>
